__turbopack_context__.v({
  "container": "SiUm7a_container",
  "eventTab": "SiUm7a_eventTab",
  "events": "SiUm7a_events",
  "loading": "SiUm7a_loading",
  "pcNav": "SiUm7a_pcNav",
});
